import * as React from 'react';
import Navigation from './uiComponents/layout/Navigation';
import Main from './uiComponents/layout/Main';
import { Component } from 'react';
import Footer from './uiComponents/layout/Footer';
import { RouteComponentProps } from 'react-router';
import { Bruger } from './models/Bruger';
import { isAuthenticated, getLoggedInBruger } from './infrastructure/Security';
import ErrorBoundary from './infrastructure/ErrorBoundary';
import { Image } from './uiComponents/layout/Image';
import { Grid } from './uiComponents/bootstrap-components/BootstrapComponents';
import { getSite } from './infrastructure/site/SiteProvider';
import { SiteEnum } from './models/enums/SiteEnum';

interface AppProps extends RouteComponentProps<any> { }

interface AppState {
    bruger?: Bruger;
    brugerWasSaved?: boolean;
}

class App extends Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);

        this.state = { bruger: undefined, brugerWasSaved: false };

        this.onBrugerSaved = this.onBrugerSaved.bind(this);
    }

    onBrugerSaved(bruger: Bruger) {
        this.setState({ bruger: bruger, brugerWasSaved: true });
    }

    getBackground() {
        let classes = getSite().type === SiteEnum.Sciencedysten ? 'sciencedysten' : '';
        classes += ' background';
        return (
            <Grid className={classes}>
                <Image source={getSite().backgroundImageName} />
            </Grid>
        );
    }

    render() {
        let bruger = this.state.bruger;
        if (isAuthenticated()) {
            bruger = getLoggedInBruger();
        }

        if (this.props.location.pathname.indexOf('scoreboard/') > 0) {
            return <Main {...this.props} />;

        } else {
            return (
                <ErrorBoundary {...this.props}>
                    <div>
                        <Navigation bruger={bruger} />

                        <div id='wrapper'>
                            {this.getBackground()}
                            <Main {...this.props} />
                            <div className='push' />
                        </div>

                        <Footer />
                    </div>
                </ErrorBoundary>
            );
        }
    }
}

export default App;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/App.tsx